<template lang="pug">
    v-container(fluid pa-0 ma-0 fill-height class="align-start tw-overflow-hidden "  )
        v-container( v-if="loading" pa-0 ma-0 fill-height fluid class="align-start" )
            v-row(no-gutters class="align-start")
                v-col
                    v-skeleton-loader(type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions" )
        v-container( v-if="!requester.contactperson && !loading" fluid fill-height  pa-0 ma-0 class=" align-start content-start" )
            v-row(no-gutters class=" align-self-start")
                v-col(cols="12")
                    v-row(no-gutters)
                        v-col
                            v-alert( type="error"  ) Contact not found
                    v-row(no-gutters)
                        v-col(class="px-2")
                            div(class=" tw-font-medium tw-text-lg") {{ requester.name }}
                            div(class=" tw-text-sm") {{ requester.email }}
            v-row(no-gutters class="align-self-end"   ) 
                v-col( class="pt-10")
                    v-btn( tile block elevation="0" height="56"  color="indigo lighten-5" class=" indigo--text text--darken-5" @click="createContact()" ) ADD CONTACT
        v-container( v-else-if="!loading" fill-height pa-0 ma-0 class="align-start" )
            v-row( no-gutters align="stretch")
                v-col
                    v-row(v-if="requester.company" no-gutters)
                        v-col()
                            v-row( class=" overflow-hidden tw-bg-blue-800 tw-rounded-t" no-gutters align="center")
                                v-col( class=" pt-0 pr-0 text-right")
                                    v-menu( bottom right )
                                        template( v-slot:activator="{on}" )
                                            v-btn( dark retain-focus-on-click icon small :ripple="false" v-on="on" )
                                                v-icon mdi-dots-vertical
                                        v-list( dense shaped  )
                                            v-list-item(key="1" @click="createOpportunity()")
                                                v-list-item-title Create Opportunity
                            v-row( class=" overflow-hidden tw-bg-blue-800")
                                v-col( class="pt-0 pb-0")
                            v-row(class=" " justify="center")
                                v-col( cols="auto" class="pa-2 tw--mt-12")
                                    v-card(:ripple='false' :href="'https://sugar.xprt.com/#Accounts/' + requester.company.idcrm" target="blank"  color=" white" our elevation="3"  width="120" height="80" class=" align-center"  )
                                        v-container( fill-height fluid pa-0 ma-0  )
                                            v-row( align="center" no-gutters)
                                                v-col
                                                    v-img(:src="'https://www.xprt.com' + requester.company.logo" contain  justify="center" align="center" class="px-2" max-height="80" max-width="120"  ) 
                            v-row( justify="center" no-gutters)
                                v-col() 
                                    v-container( fluid px-4 pt-2 pb-0 ma-0  )
                                        v-row( class="tw-bg-gray-200 tw-h-8 tw-rounded-full tw-w-full tw-border-t tw-border-l tw-border-gray-300" no-gutters align="center")
                                            v-col()
                                                v-row(no-gutters class=" tw-w-full tw-justify-center tw-text-center")
                                                    v-col( class=" tw-border-r tw-border-gray-300")
                                                        span( class="tw-pl-2 tw-text-gray-600 tw-pt-2 tw-font-semibold") {{ requester.company.staff }}
                                                    v-col
                                                        span( class="tw-pl-2 tw-text-gray-600 tw-pt-2 tw-font-semibold") Rank {{ requester.company.rank }}
                                                    v-col( class="tw-border-l tw-border-gray-300")
                                                        span( class="tw-pl-2 tw-text-gray-600 tw-pt-2 tw-font-semibold tw-uppercase") {{ requester.company.xprt_level }} 
                                                        
                    v-row(no-gutters align="stretch" class=" self-start pt-2 px-2"  )
                        v-col()
                            v-card(  flat :ripple='false' :href="'https://sugar.xprt.com/#Contacts/' + requester.contactperson.IDCRMCONTACTO" target="blank" class="pa-1"  )
                                v-row( no-gutters)
                                    v-col(v-if="requester.contactperson.PROFILEPICTURE" cols="auto" class="pr-1")
                                        v-avatar
                                            v-img( :src="'https://www.xprt.com/' + requester.contactperson.PROFILEPICTURE" )
                                    v-col(v-else cols="auto")
                                        v-avatar
                                            v-icon(x-large ) mdi-account-circle-outline
                                    v-col(class="content-start")                              
                                        div( class=" grey--text text--darken-1 tw-font-semibold tw-text-lg") 
                                            |{{ requester.contactperson.FIRSTNAME }} {{ requester.contactperson.LASTNAME }}
                                            span(v-if="requester.contactperson.dmu" class=" tw-text-sm pl-2 mb-1") (DMU) 
                                        div( class=" grey--text text--darken-1 tw-font-medium tw--mt-1 tw-text-sm") 
                                            span(v-if="requester.contactperson.POSITION" class="mr-2") {{ requester.contactperson.POSITION }}
                                            v-chip(x-small class="grey--text text--darken-1 tw-text-base") {{ requester.contactperson.USERTYPE }}
                                v-row(no-gutters justify="space-between" class="pt-2 px-2")
                                    v-col(cols="auto")
                                        div( class=" grey--text text--darken-1 tw-font-medium tw--mt-1 tw-text-sm") 
                                            v-icon(small class="pr-1" ) mdi-phone-classic
                                            span(v-if="requester.contactperson.PHONE") {{ requester.contactperson.PHONE }}
                                            span(v-else class=" red--text") Not found!
                                v-row(no-gutters class="pt-1 px-2")
                                    v-col(cols="auto")
                                        div( class=" grey--text text--darken-1  tw-font-medium tw--mt-1 tw-text-sm ") 
                                            v-icon(small class="pr-1") mdi-email-variant
                                            |{{ requester.contactperson.email }}
                    
                    v-row(no-gutters v-if="requester" class="tw-pt-1")
                        v-col( v-for="opportunity in requester.company.opportunities" :key="opportunity.id")
                            opportunities-list-item(:opportunity="opportunity")
</template>

<script>
export default {
    data(){
        return{
            requester: {
                name: '',
                email: '',
                company: {
                    opportunities: {}
                }
            },
            opportunities: {},
            loading: true
        }
    },
    created() {
        this.getRequester()
    },
    methods: {
        getRequester(){
            this.$zd.get('ticket.requester')
                .then(response => {
                    this.requester = response['ticket.requester']
                    this.$http.get(this.$api_url + 'contact/details/' + this.requester.email, {
                                headers: {
                                'OAuth-Token': this.$store.getters.token
                                }
                            })
                            .then(response => {
                                this.requester.contactperson = response.data[0]
                                if (this.requester.contactperson){
                                    this.$http.get(this.$api_url + 'companies/detail/' + this.requester.contactperson.IDFREEPROFILE, {
                                        headers: {
                                        'OAuth-Token': this.$store.getters.token
                                        }
                                    })
                                    .then(response => {
                                        this.requester.company = response.data.description[0]
                                        this.$http.post(this.$api_url + 'sugar/get', {
                                            token: this.$store.getters.token,
                                            record_type: 'Opportunities',
                                            body:{
                                                filter:[{
                                                    account_id: this.requester.company.idcrm,
                                                    sales_stage:{
                                                        $not_in : [
                                                            'Closed won',
                                                            'Closed lost'
                                                        ]
                                                    }
                                                }],
                                                max_num: 1
                                            }
                                        })
                                        .then(response => {
                                            this.requester.company.opportunities = response.data.records
                                            this.loading = false
                                        })
                                        .catch(error => {
                                            console.log(error)
                                        })
                                        
                                    })
                                    .catch(error => {
                                        if(error.response.status === 401){
                                            this.$router.push('/logout')
                                        }
                                        
                                    })
                                }else{
                                    this.loading = false
                                }
                            })
                            .catch(error => {
                                if(error.response.status === 401){
                                    this.$router.push('/logout')
                                }
                            })
                })
                .catch(error => {
                    if(error.response.status === 401){
                        this.$router.push('/logout')
                    }
                })
        },

        createOpportunity(){
            this.$router.push({name:'CreateOpportunity', params:{ requester: this.requester }})
        },
        createContact(){
            this.$router.push({name:'CreateContact', params:{ requester: this.requester }})
        }
    },
}
</script>

<style lang="stylus" scoped>
.v-card--link:before {
  display: none;
}
</style>